export default {"src":"https://static.finncdn.no/_c/travel/pp-web/_next/static/media/cz.70c9b459.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};